// 获取审批类型'NONE'-单人审批， 'AND'-会签 'OR'-或签
export const getType = (actionType) => {
  const type =
    // eslint-disable-next-line no-nested-ternary
    actionType === 'NONE'
      ? 1
      // eslint-disable-next-line no-nested-ternary
      : actionType === 'AND'
        ? 2
        : actionType === 'OR'
          ? 3
          : actionType || 4
  return type
}

